<template>
  <div>
    <a-form-model
      class="fromStyle"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item ref="date" label="入库日期" prop="date">
        <a-date-picker @change="onChange" v-model="form.date" />
      </a-form-model-item>
      <a-form-model-item label="项目" ref="project_id" prop="project_id">
        <a-select
          style="width:300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          @change="selectGoods"
          v-model="form.project_id"
          placeholder="请选择项目"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="入库类型" prop="in_type">
        <a-radio-group v-model="form.in_type">
          <a-radio :value="1">
            公司
          </a-radio>
          <a-radio :value="2">
            管家
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="入库数据" v-show="showIsGoods">
        <table class="goodsList">
          <thead>
            <th>商品</th>
            <th>商品图</th>
            <th>入库数量</th>
          </thead>
          <tbody>
            <tr v-for="(item, i) in goodsList" :key="i">
              <td>{{ item.brand_name }}</td>
              <td>
                <img :src="item.imageUrl.url_thumb" alt="" />
              </td>
              <td>
                <a-input-number :min="0" v-model="item.number" />
              </td>
            </tr>
          </tbody>
        </table>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 5 }">
        <a-button @click="resetForm">
          重置
        </a-button>
        <a-button style="margin-left: 10px;" type="primary" @click="onSubmit">
          提交
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
import * as qiniu from "qiniu-js";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      form: {
        date: "",
        project_id: "",
        in_date: "",
        number: "",
        material_list: "",
        in_type: ""
      },
      rules: {
        in_type: [
          { required: true, message: "请选择入库类型", trigger: "change" }
        ],
        date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ]
      },
      proList: [],
      goodsList: [],
      showIsGoods: false
    };
  },
  mounted() {
    this.getPro();
  },
  methods: {
    selectGoods(id) {
      this.showIsGoods = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Brand/getBrandList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        count_type: 1,
        project_id: id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.goodsList = res.data.data;
          // console.log(this.goodsList);
        }
      });
    },
    onChange(date, dateString) {
      this.form.in_date = dateString;
      // console.log(dateString);
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    verify() {
      let fls = true;
      this.form.material_list = [];
      this.goodsList.forEach(item => {
        if (
          item.number == undefined ||
          item.number == "" ||
          item.number == null
        ) {
          this.form.number = "";
          fls = false;
          return fls;
        } else {
          this.form.number = 1;
          this.form.material_list.push({
            brand_id: item.id,
            num: item.number
          });
        }
      });
      return fls;
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.equipment +
            "Project_material/in";

          this.form.material_list = [];
          this.goodsList.forEach(item => {
            if (item.number > 0) {
              this.form.material_list.push({
                brand_id: item.id,
                num: item.number
              });
            } else {
              this.form.number = "";
            }
          });
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            in_date: this.form.in_date,
            project_id: this.form.project_id,
            in_type: this.form.in_type,
            material_list: JSON.stringify(this.form.material_list)
          };
          // console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.$refs.ruleForm.resetFields();
              this.$emit("hideInAdd", true);
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style lang="less">
.fromStyle {
  margin-top: 30px;
  .goodsList {
    min-width: 300px;
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
    }
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
    line-height: 32px;
  }
  .upImgStyle {
    position: relative;
    display: inline-block;
    min-width: 300px;
    vertical-align: top;
    > input {
      vertical-align: top;
      opacity: 0;
      position: absolute;
      width: 100px;
      height: 100px;
      margin-right: 10px;
      margin-top: 10px;
      z-index: 1;
    }
    > img {
      vertical-align: top;
      display: inline-block;
      border: 1px solid #d9d9d9;
      width: 100px;
      height: 100px;
      text-align: center;
      line-height: 100px;
      margin-right: 10px;
      margin-top: 10px;
      i {
        line-height: 100px;
      }
    }
  }
}
</style>
